import { Injectable, inject } from '@angular/core';
import { PLATFORM_CONFIG } from '@platform/config';
import type { PlatformConfig } from '@platform/config';

export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
  NONE = 4,
}

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private readonly config = inject<PlatformConfig>(PLATFORM_CONFIG);
  private readonly minLevel = this.config.debug ? LogLevel.DEBUG : LogLevel.INFO;

  debug(message: string, ...args: unknown[]): void {
    if (this.minLevel <= LogLevel.DEBUG) {
      console.debug(`[DEBUG] ${message}`, ...args);
    }
  }

  info(message: string, ...args: unknown[]): void {
    if (this.minLevel <= LogLevel.INFO) {
      console.info(`[INFO] ${message}`, ...args);
    }
  }

  warn(message: string, ...args: unknown[]): void {
    if (this.minLevel <= LogLevel.WARN) {
      console.warn(`[WARN] ${message}`, ...args);
    }
  }

  error(message: string, error?: Error | unknown, ...args: unknown[]): void {
    if (this.minLevel <= LogLevel.ERROR) {
      console.error(`[ERROR] ${message}`, error, ...args);
      
      // Send to error tracking if enabled
      if (this.config.integrations?.errorTracking?.enabled) {
        this.sendToErrorTracking(message, error);
      }
    }
  }

  private sendToErrorTracking(message: string, error?: Error | unknown): void {
    // Integration with error tracking service
    // This would be implemented based on the specific error tracking service
    try {
      // Example: Sentry, LogRocket, etc.
      // errorTrackingService.captureException(error, { message });
    } catch (e) {
      // Silently fail to avoid infinite loops
    }
  }
}

